import axios from "axios";
import config from "../../../config/index";

import {
    POST_ARTICLE,
    PUBLISHED_ALL,
    ARTICLES_ALL,
    ARTICLE_DETAILS,
    ARTICLE_DELETE,
    CATEGORY_LIST,
    CATEGORY_ADD,
    UPDATE_ARTICLE,
    ARTICLE_DETAILS_DISPLAY,
    POST_COMMENT,
    GET_COMMENT_BYID, SHOW_SPINNING,
} from "../types/types";

const instance = axios.create({
    baseURL: config.SIM_API_URL,
    timeout: 30000,
});

// Add a response interceptor
instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {

    if(error.response.status === 403) {
        localStorage.setItem("role", '');
        localStorage.setItem("client", '');
        localStorage.setItem("client_id", '');
        localStorage.setItem("client_name", '');
        localStorage.setItem("client_email", '');
        window.location.href = "/login";
    }
    return Promise.reject(error);
});

export const reset = () => dispatch => {
    dispatch({
        type: POST_ARTICLE,
        payload: '',
    });
    dispatch({
        type: UPDATE_ARTICLE,
        payload: '',
    });
    dispatch({
        type: ARTICLE_DELETE,
        payload: '',
    });
    dispatch({
        type: CATEGORY_ADD,
        payload: '',
    });
    dispatch({
        type: POST_COMMENT,
        payload: '',
    });
};

export const postArticle = (data) => dispatch => {
    dispatch({type: SHOW_SPINNING, payload: true});
    instance
        .post("api/articles/post-article", data)
        .then(res => {
            console.log("Post Success -> ", res.data.msg);
            dispatch({type: SHOW_SPINNING, payload: false});
            dispatch({
                type: POST_ARTICLE,
                payload: res.data.msg,
            });
        })
        .catch(err => {
            console.log("Post Failed -> ", err.response.data.msg);
            dispatch({type: SHOW_SPINNING, payload: false});
            dispatch({
                type: POST_ARTICLE,
                payload: err && err.response && err.response.data && err.response.data.msg,
            });
        })
};

export const updateArticle = (data) => dispatch => {
    dispatch({type: SHOW_SPINNING, payload: true});
    instance
        .post("api/articles/update-article", data)
        .then(res => {
            console.log("The article updated successfully -> ", res.data.msg);
            dispatch({type: SHOW_SPINNING, payload: false});
            dispatch({
                type: UPDATE_ARTICLE,
                payload: res.data.msg,
            });

        })
        .catch(err => {
            console.log("Update Failed -> ", err && err.response && err.response.data && err.response.data.msg);
            dispatch({type: SHOW_SPINNING, payload: false});
            dispatch({
                type: UPDATE_ARTICLE,
                payload: err && err.response && err.response.data && err.response.data.msg,
            });
        })
};

export function articleImageUpload(data) {
    return instance.post("api/documents/file-upload", data);
}

export const getPublishedArticle = (data) => dispatch => {
    dispatch({type: SHOW_SPINNING, payload: true});
    instance
        .post("api/articles/get-published", data)
        .then(res => {
            dispatch({type: SHOW_SPINNING, payload: false});
            dispatch({
                type: PUBLISHED_ALL,
                payload: res.data.results,
            });
        })
        .catch(err => {
            dispatch({type: SHOW_SPINNING, payload: false});
            console.log(err && err.response && err.response.data && err.response.data.msg);
        })
};

export const getAllArticles = (data) => dispatch => {
    dispatch({type: SHOW_SPINNING, payload: true});
    instance
        .post("api/articles/get-all-articles", data)
        .then(res => {
            console.log(res.data.msg);
            dispatch({type: SHOW_SPINNING, payload: false});
            dispatch({
                type: ARTICLES_ALL,
                payload: res.data.results,
            });
        })
        .catch(err => {
            dispatch({type: SHOW_SPINNING, payload: false});
            console.log(err && err.response && err.response.data && err.response.data.msg);
        })
};

export const getArticleDetails = (data) => dispatch => {
    dispatch({type: SHOW_SPINNING, payload: true});
    instance
        .post("api/articles/edit-article", data)
        .then(res => {
            console.log(res.data.results);
            dispatch({type: SHOW_SPINNING, payload: false});
            dispatch({
                type: ARTICLE_DETAILS,
                payload: res.data.results,
            });
        })
        .catch(err => {
            dispatch({type: SHOW_SPINNING, payload: false});
            console.log(err && err.response && err.response.data && err.response.data.msg);
        })
};

export const getArticleDetailsById = (data) => dispatch =>{
    dispatch({type: SHOW_SPINNING, payload: true});
    instance
        .post("api/articles/get-article", data)
        .then(res => {
            console.log(res.data.results);
            dispatch({type: SHOW_SPINNING, payload: false});
            dispatch({
                type: ARTICLE_DETAILS_DISPLAY,
                payload: res.data.results,
            });
        })
        .catch(err => {
            dispatch({type: SHOW_SPINNING, payload: false});
            console.log("Getting of the article's details by Id failed.", err && err.response && err.response.data && err.response.data.msg);
        })
};

export const deleteArticle = (data) => dispatch => {
    dispatch({type: SHOW_SPINNING, payload: true});
    instance
        .post("api/articles/delete-article", data)
        .then(res => {
            dispatch({type: SHOW_SPINNING, payload: false});
            console.log(res.data.msg);
            dispatch({
                type: ARTICLE_DELETE,
                payload: res.data.msg,
            });
        })
        .catch(err => {
            dispatch({type: SHOW_SPINNING, payload: false});
            console.log("Deleting of the article failed.", err && err.response && err.response.data && err.response.data.msg);
            dispatch({
                type: ARTICLE_DELETE,
                payload: err && err.response && err.response.data && err.response.data.msg,
            });
        })
};

/**
 * Adding the category
 */
export const addCategory = (data) => dispatch => {
    dispatch({type: SHOW_SPINNING, payload: true});
    instance
        .post("api/articles/add-category", data)
        .then(res => {
            console.log(res.data.msg);
            dispatch({type: SHOW_SPINNING, payload: false});
            dispatch({
                type: CATEGORY_ADD,
                payload: res.data.msg,
            });
        })
        .catch(err => {
            console.log("Adding the category failed.", err && err.response && err.response.data && err.response.data.msg);
            dispatch({type: SHOW_SPINNING, payload: false});
            dispatch({
                type: CATEGORY_ADD,
                payload: err && err.response && err.response.data && err.response.data.msg,
            });
        })
};

export const getListCategory = () => dispatch => {
    dispatch({type: SHOW_SPINNING, payload: true});
    instance
        .post("api/articles/get-category-list",)
        .then(res => {
            console.log(res.data.msg);
            dispatch({type: SHOW_SPINNING, payload: false});
            dispatch({
                type: CATEGORY_LIST,
                payload: res.data.results,
            });
        })
        .catch(err => {
            dispatch({type: SHOW_SPINNING, payload: false});
            console.log("Getting of the category list failed.", err && err.response && err.response.data && err.response.data.msg);
        })
};

/**
 * Comment
 */
export const postComment = (data) => dispatch => {
    dispatch({type: SHOW_SPINNING, payload: true});
    instance
        .post("api/articles/post-comment", data)
        .then(res => {
            console.log(res.data.msg);
            dispatch({type: SHOW_SPINNING, payload: false});
            dispatch({
                type: POST_COMMENT,
                payload: res.data.msg,
            });
        })
        .catch(err => {
            dispatch({type: SHOW_SPINNING, payload: false});
            console.log("Posting of the comment failed.", err && err.response && err.response.data && err.response.data.msg);
        })
};

/**
 * Getting the comments by article ID
 * @type {Router}
 */
export const getArticleCommentById = (data) => dispatch => {
    dispatch({type: SHOW_SPINNING, payload: true});
    instance
        .post("api/articles/get-comment", data)
        .then(res => {
            console.log(res.data.msg);
            dispatch({type: SHOW_SPINNING, payload: false});
            dispatch({
                type: GET_COMMENT_BYID,
                payload: res.data.results,
            });
        })
        .catch(err => {
            dispatch({type: SHOW_SPINNING, payload: false});
            console.log("Posting of the comment failed.", err && err.response && err.response.data && err.response.data.msg);
        })
};
